import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  StyleProfileNextBestActionDefinitionByCustomerIdView,
  ViewStyleProfileNextBestActionDefinitionByCustomerIdResult,
} from "../../../projection/nextBestActionDefinition/viewStyleProfileNextBestActionDefinitionByCustomerId";

interface HttpStyleProfileNextBestActionDefinitionByCustomerIdView extends StyleProfileNextBestActionDefinitionByCustomerIdView {}

interface HttpStyleProfileNextBestActionDefinitionByCustomerIdViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpStyleProfileNextBestActionDefinitionByCustomerIdViewFunction {
  (
    args: HttpStyleProfileNextBestActionDefinitionByCustomerIdViewFunctionArgs,
  ): HttpStyleProfileNextBestActionDefinitionByCustomerIdView;
}

const httpStyleProfileNextBestActionDefinitionByCustomerIdView: HttpStyleProfileNextBestActionDefinitionByCustomerIdViewFunction =

    ({ httpPost }) =>
    async ({ customerId, signal }) =>
      await httpPost<ViewStyleProfileNextBestActionDefinitionByCustomerIdResult>({
        endpoint: "/v2/view-style-profile-next-best-action-definition-by-customer-id",
        body: { customerId },
        signal,
        result: {
          error: null,
          success: (response) => response,
        },
      });

export { httpStyleProfileNextBestActionDefinitionByCustomerIdView };
